import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { api } from "../../api/client";
import { qk } from "../../api/queries";
import { ErrorBox, Spinner } from "../../components/Spinner";
import { formatUsd } from "../../lib/format";

export function UsageSettings({ pid }: { pid: string }) {
  const { data, isLoading, error } = useQuery({ queryKey: qk.usage(pid), queryFn: () => api.usage(pid) });
  if (isLoading) return <Spinner />;
  if (error) return <ErrorBox error={error} />;
  if (!data) return null;
  return (
    <div>
      <div className="stat-row">
        <div className="stat">
          <div className="stat-value">{formatUsd(data.total_cost_usd)}</div>
          <div className="muted small">Agent cost</div>
        </div>
        <div className="stat">
          <div className="stat-value">{Math.round(data.total_env_minutes / 60)} h</div>
          <div className="muted small">Environment time</div>
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Task</th>
            <th className="num">Runs</th>
            <th className="num">Cost</th>
            <th className="num">Env minutes</th>
          </tr>
        </thead>
        <tbody>
          {data.tasks.map((t) => (
            <tr key={t.task_id}>
              <td>
                <Link to={`/p/${pid}/tasks/${t.task_id}`}>
                  <span className="muted">#{t.number}</span> {t.title}
                </Link>
              </td>
              <td className="num">{t.runs}</td>
              <td className="num">{formatUsd(t.cost_usd)}</td>
              <td className="num">{Math.round(t.env_minutes)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
